import * as types from './types';
import { loading } from 'State/actions';
import { toastInfo, toastSuccess } from 'Common/ToastHelper';

export const postMealSummaries = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.UNCLOSE_DAY_FETCHING_UNCLOSE, true));

    try {
      const url = `uncloseday/WriteUncloseDays`;
      const response = await MPWWebApi.postGenericInsertUpdate(url, model);

      dispatch({
        type: types.UNCLOSE_DAY_PROCESS,
        payload: response.data.Data,
      });

      toastSuccess('Day(s) unclosed successfully!');
    } catch (error) {
      dispatch({
        type: types.UNCLOSE_DAY_ERRORS,
        payload: error.response,
      });
    }

    dispatch(loading(types.UNCLOSE_DAY_FETCHING_UNCLOSE, false));
  };
};

export const clearError = () => {
  return {
    type: types.UNCLOSE_DAY_CLEAR_ERRORS,
  };
};

export const getMealSummaries = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.UNCLOSE_DAY_FETCHING, true));

    try {
      const url = `uncloseday/getcloseddays`;
      const response = await MPWWebApi.postGenericInsertUpdate(url, model);

      if (!response.data.Data || response.data.Data.length === 0) {
        toastInfo('No data found!');
        dispatch({
          type: types.UNCLOSE_DAY_CLEAR_SUMMARIES,
        });
      } else {
        dispatch({
          type: types.UNCLOSE_DAY_GET_DATA,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      dispatch({
        type: types.UNCLOSE_DAY_ERRORS,
        payload: error.response,
      });
    }

    dispatch(loading(types.UNCLOSE_DAY_FETCHING, false));
  };
};

export const clearMealSummaries = () => {
  return {
    type: types.UNCLOSE_DAY_CLEAR_SUMMARIES,
  };
};

export const setIsSelected = row => {
  return {
    type: types.UNCLOSE_DAY_UPDATE_SELECTED,
    payload: row,
  };
};



// WEBPACK FOOTER //
// ./src/pages/uncloseday/state/uncloseday/actions.js